import { EcpServices } from '../../ecp-locator';
import { ButtonColorStyle } from '../../../../common/button-new/button.models';

export const getServiceButton = (service?: EcpServices): { label: string, style: ButtonColorStyle } => {
  switch (service) {
    case EcpServices.aec:
      return { label: '', style: 'cv' };
    case EcpServices.cv:
      return { label: 'common.cv.action', style: 'cv' };
    default:
      return { label: 'appointment.requestButton.label', style: 'dark' };
  }
};
